<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    For Installation
                  </v-toolbar-title>
                </div>
                <div class="ml-auto">
                  <v-btn
                    color="warning"
                    @click.prevent="assignTo"
                    :disabled="table.selected.length <= 0"
                  >
                    <v-icon class="mr-2">mdi-highway</v-icon> Dispatch
                  </v-btn>
                  <!-- <v-btn color="primary" class="ml-auto">
                    <download-csv :data="exportData" :name="`${fileName}.csv`">
                      <v-icon dense>mdi-download</v-icon>
                      Export
                    </download-csv>
                  </v-btn> -->
                </div>
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            v-model="table.selected"
            @input="enterSelect()"
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="_id"
            :search="search"
            loading-text="Loading... Please wait"
            class="elevation-1"
            :single-select="false"
            show-select
          >
            <!-- <template
        v-for="header in headers.filter((header) =>
          header.hasOwnProperty('formatter')
        )"
        v-slot:[`item.${header.value}`]="{ value }"
      >
        {{ header.formatter(value) }}
      </template> -->
            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>

            <template v-slot:[`item.name`]="{ item }">
              {{ item.name
              }}<span v-if="item.middleName">, {{ item.middleName }}</span>
            </template>

            <template v-slot:[`item.isPaid`]="{ item }">
              {{ item.isPaid ? "Yes" : "No" }}
            </template>

            <template v-slot:[`item.amountPaid`]="{ item }">
              {{ item.amountPaid ? item.amountPaid.toLocaleString() : 0 }}
            </template>
            <template v-slot:[`item.approvedJO`]="{ item }">
              {{ item.approvedJO ? "Manual" : "Auto" }}
            </template>

            <template v-slot:[`item.account.jo_no`]="{ item }">
              {{ item.account.jo_no ? item.account.jo_no : "-" }}
            </template>

            <!-- <template v-slot:[`item.actions`]="{ item }">
              <v-btn x-small color="warning" dark @click="assignTo(item)">
                Dispatch</v-btn
              >
            </template> -->
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <AssignForInstallation ref="assignForInstallation" />
  </v-container>
</template>

<script>
import moment from "moment";
import AssignForInstallation from "../dialogs/acquisition/AssignForInstallation.vue";
export default {
  name: "IbasForInstallation",
  components: {
    AssignForInstallation,
  },
  data() {
    return {
      exportData: [],
      fileName: "",

      isExporting: false,
      search: "",
      paths: {
        viewInfo: "/draw/view",
      },

      table: {
        selected: [],
        // sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        headers: [
          {
            text: "Payment Date",
            align: "start",
            value: "paymentDate",
            sortable: true,
            width: "10%",
            formatter: (x) => (x ? moment(x).format("MMM DD, YYYY") : null),
          },
          {
            text: "JO Number",
            align: "start",
            sortable: false,
            value: "account.jo_no",
          },
          {
            text: "City",
            align: "start",
            value: "city",
          },
          {
            text: "Area",
            align: "start",
            value: "area",
          },
          {
            text: "Subscriber Name",
            align: "start",
            value: "name",
          },
          // {
          //   text: "Paid",
          //   align: "center",
          //   value: "isPaid",
          // },

          {
            text: "Manual/Auto JO",
            align: "center",
            value: "approvedJO",
          },
          {
            text: "Acquirer",
            align: "start",
            value: "acquirer",
            sortable: false,
          },
          {
            text: "Territory Head",
            align: "start",
            value: "territoryHead",
            sortable: false,
          },
          // {
          //   text: "Amount Paid",
          //   align: "start",
          //   value: "amountPaid",
          //   sortable: false,
          // },

          {
            text: "Assigned To",
            align: "start",
            value: "dispatch.assignedTo",
            sortable: true,
          },

          {
            text: "Status",
            align: "start",
            value: "dispatch.status",
            sortable: true,
          },

          {
            text: "Installation Date",
            align: "start",
            value: "dispatch.installationDate",
            sortable: true,
            width: "10%",
            formatter: (x) => (x ? moment(x).format("MMM DD, YYYY") : null),
          },

          // {
          //   text: "Actions",
          //   align: "center",
          //   value: "actions",
          //   sortable: false,
          // },
        ],
        data: [],
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    async getList() {
      this.table.loading = true;
      await this.$api
        .get("/acquisition/report?report=paid")
        .then((response) => {
          const newArr = response.data.data;
          this.table.data = newArr;
          let exportData = newArr.map((item) => {
            return {
              // "Payment Date": moment(item.paymentDate).format("MM/DD/YYYY"),
              "Payment Date": item.paymentDate,
              "JO Number": item.account.jo_no ? "'" + item.account.jo_no : "",
              "Account Number": item.accountNumber,
              "Referrence Number": item.referenceNumber,
              Name: `${item.name}${
                item.middleName ? ", " + item.middleName : ""
              }`,
              Address: item.address,
              Municipality: item.city,
              "Dispatch to": "",
              Category: "",
              "Contact Details": item.mobileNumber,
              Remarks: "",
              Plan: "",
              Area: item.area,
              "Manual/Auto JO": item.approvedJO ? "Manual" : "Auto",
              Acquirer: item.acquirer,
              "Territory Head": item.territoryHead,
            };
          });

          exportData.sort(function(a, b) {
            return new Date(b["Payment Date"]) - new Date(a["Payment Date"]);
          });

          this.fileName = `for_installation_as_of_${moment(
            moment().toDate()
          ).format("MMM_DD_YYYY")}`;
          this.exportData = exportData;

          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    // async exportData() {
    //   this.isExporting = true;
    //   await this.$api
    //     .post("/export", {
    //       method: "exportByStatus",
    //       status: "PAID",
    //     })
    //     .then((response) => {
    //       // console.log(response);
    //       const res = response.data;
    //       this.isExporting = false;

    //       if (!res.status) {
    //         alert(
    //           "Something went wrong. Please reload the page and export again."
    //         );
    //         return;
    //       }

    //       var fileLink = document.createElement("a");
    //       fileLink.href = res.data.link;
    //       document.body.appendChild(fileLink);
    //       fileLink.click();
    //     })
    //     .catch((e) => {
    //       // this.table.loading = false;
    //       this.isExporting = false;
    //       console.log(e);
    //     });
    // },

    async assignTo() {
      await this.$refs.assignForInstallation
        .open(this.table.selected)
        .then((response) => {
          if (response) {
            this.table.selected = [];
            this.getList();
          }
        });
    },

    enterSelect() {
      console.log(this.table.selected.map((e) => e.referenceNumber)); // logs all the selected items.
    },
  },
  created() {
    this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>
